import { render, staticRenderFns } from "./classRoomSelector.vue?vue&type=template&id=a075d4d8&"
import script from "./classRoomSelector.vue?vue&type=script&lang=js&"
export * from "./classRoomSelector.vue?vue&type=script&lang=js&"
import style0 from "./classRoomSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports